
import React from "react";
import './Carousel.css';


const s3URL =
    "https://popcorn-images-prod.s3.us-west-2.amazonaws.com/party/datadisplay/";


export type ScrollFunction = () => number;

export type CarouselProps = {
    display: number;
    width: number;
    scrollButtonWidth: number;
    height: number;
    idPrefix: string;
    panels: JSX.Element[];
    userControlled: boolean;
    borderRadius? : number;
    scrollLeft?(func: ScrollFunction): void;
    scrollRight?(func: ScrollFunction): void;
    notifyOnClick?: (index: number) => void;

}


const CalculatePanelPositions = (index: number, n: number, width: number, array: number[], toIndex?: number) => {
    if (array.length > 0) {
        array.splice(0);
    }

    const to = toIndex ?? index;

    const half = Math.round(n / 2 - 0.1);



    for (let i = 0; i < n; i++) {
        var right = false;
        if (i < to) {
            if (i < (to - half)) {
                right = true;
            }
            else {
                right = false;
            }
        }
        else {
            if (i > (index + half)) {
                right = false;
            }
            else {
                right = true;
            }
        }

        if (i < index) {
            if (right) {
                const x = (n - index + i) * width;
                array.push(x);
            }
            else {
                const x = (i - index) * width;
                array.push(x);
            }
        }
        else if (i === index)
            array.push(0);
        else {
            if (!right) {
                const x = (i - n - index) * width;
                array.push(x);
            }
            else {
                const x = (i - index) * width;
                array.push(x);
            }
        }
    }
}

export const Carousel = ({ width, height, idPrefix, panels, scrollButtonWidth, borderRadius, display, userControlled, scrollLeft, scrollRight, notifyOnClick }: CarouselProps): React.JSX.Element => {
    const currentIndex = React.useRef<number>(0);
    const currentPanels = React.useRef<HTMLDivElement[]>([]);
    const numberOfPanels = React.useRef<number>(panels.length);
    numberOfPanels.current = panels.length;
    const positions = new Array<number>();
    CalculatePanelPositions(currentIndex.current, panels.length, width / display, positions);

    const lastClick = React.useRef<number>(0);

    const _scrollLeft = (): number => {
        onLeftClick();
        return currentIndex.current;

    }

    const _scrollRight = (): number => {
        onRightClick();
        return currentIndex.current;
    }
    if (scrollLeft !== undefined)
        scrollLeft(_scrollLeft);
    if (scrollRight !== undefined)
        scrollRight(_scrollRight);





    React.useEffect(() => {
        const arr = new Array<HTMLDivElement>()
        for (let i = 0; i < panels.length; i++) {
            const element = document.getElementById(idPrefix + "Panel" + i);
            arr.push((element as HTMLDivElement))
        }
        currentPanels.current = arr;
    });

    const onRightClick = () => {
        if (currentPanels.current.length < 2)
            return;

        const now = Date.now();
        if (lastClick.current > (now - 2000))
            return;
        else
            lastClick.current = now;
        //const prevIndex = currentPanel === 0 ? 4 : currentPanel - 1;
        if (currentPanels.current.length === 2) {
            if (currentIndex.current > 0)
                return;
            else {
                currentIndex.current = 1;
                currentPanels.current[0].className = 'transitionOn';
                currentPanels.current[1].className = 'transitionOn';
                currentPanels.current[0].style.left = (-width) + 'px';
                currentPanels.current[1].style.left = '0px';

                const lb = document.getElementById(idPrefix + "LeftButton");
                const rb = document.getElementById(idPrefix + "RightButton");
                if(lb !== null)
                    lb.style.visibility = 'visible';
                if(rb!==null)
                    rb.style.visibility = 'hidden';
            }
        }
        else {
            const nextIndex = currentIndex.current === (panels.length - 1) ? 0 : currentIndex.current + 1;
            CalculatePanelPositions(nextIndex, panels.length, width / display, positions)



            for (let i = currentIndex.current; i < currentIndex.current + currentPanels.current.length; i++) {
                const index = i >= currentPanels.current.length ? i - currentPanels.current.length : i;

                if (index === nextIndex) {
                    currentPanels.current[index].className = "transitionOn";
                }
                else if (i >= currentIndex.current && i < (currentIndex.current + display)) {
                    currentPanels.current[index].className = "transitionOn";
                }
                else {
                    currentPanels.current[index].className = "transitionOff";
                }
                currentPanels.current[index].style.left = positions[index] + "px";
            }

            currentIndex.current = nextIndex;
            if (notifyOnClick !== undefined)
                notifyOnClick(nextIndex);
        }
    }

    const onLeftClick = () => {
        const now = Date.now();
        if (currentPanels.current.length < 2)
            return;
        if (lastClick.current > (now - 2000))
            return;
        else
            lastClick.current = now;
        if (currentPanels.current.length === 2) {
            if (currentIndex.current < 1)
                return;
            else {
                currentIndex.current = 0;
                currentPanels.current[0].className = 'transitionOn';
                currentPanels.current[1].className = 'transitionOn';
                currentPanels.current[0].style.left = '0px';
                currentPanels.current[1].style.left =  width + 'px';
                const lb = document.getElementById(idPrefix + "LeftButton");
                const rb = document.getElementById(idPrefix + "RightButton");
                if(lb !== null)
                    lb.style.visibility = 'hidden';
                if(rb!==null)
                    rb.style.visibility = 'visible';
            }
        }
        else {
            const prevIndex = currentIndex.current === 0 ? (panels.length-1) : currentIndex.current - 1;

            CalculatePanelPositions(prevIndex, panels.length, width / display, positions)

            for (let i = currentIndex.current; i < currentIndex.current + currentPanels.current.length; i++) {
                const index = i >= currentPanels.current.length ? i - currentPanels.current.length : i;
                if (index == prevIndex) {
                    currentPanels.current[index].className = "transitionOn";
                }
                else if (i >= currentIndex.current && i < (currentIndex.current + display)) {
                    currentPanels.current[index].className = "transitionOn";
                }
                else {
                    currentPanels.current[index].className = "transitionOff";

                }
                currentPanels.current[index].style.left = positions[index] + "px";
            }

            currentIndex.current = prevIndex;
            if (notifyOnClick !== undefined)
                notifyOnClick(prevIndex);
        }

    }

    const leftButtonVisibility = numberOfPanels.current > 2 ? 'visible' : (currentIndex.current > 0 ? 'visible' : 'hidden');
    const rightButtonVisibility = numberOfPanels.current > 2 ? 'visible' : (currentIndex.current < 1 ? 'visible' : 'hidden');





    return (
        <div style={{ height: height + "px", width: width + "px", backgroundColor: "black", display: "flex", flexDirection: "row", borderRadius: (borderRadius ?? 25) + "px", overflow: "clip", position: 'relative' }} id={idPrefix}>

            <div id={idPrefix + "MainPanel"}
                style={{ width: (width - 100) + "px", height: height + "px", backgroundColor: "black", position: "relative", overflow: "visible" }}>
                {
                    positions.map((left: number, index: number) => {
                        return <div id={idPrefix + "Panel" + index} key={idPrefix + "Panel" + index} className="transitionOff"
                            style={{ width: (width - 100) + "px", height: height + "px", backgroundColor: "black", top: "0px", left: left + "px" }}>
                            {
                                panels[index]
                            }
                        </div>
                    })}

            </div>
            {(userControlled && (panels.length > 1)) &&
                <div
                    id={idPrefix + "LeftButton"}
                    style={{
                        width: scrollButtonWidth + "px",
                        height: height + "px",
                        position: 'absolute',
                        left: '0px',
                        top: '0px',
                        visibility : leftButtonVisibility
                    }}
                    className="carouselButtonPanel"
                    onClick={() => {
                        onLeftClick();
                    }}>
                    <img
                        src={s3URL + "leftCarouselButton.png"}
                        style={{
                            width: (0.6 * scrollButtonWidth) + "px",
                            maxWidth: (0.6 * scrollButtonWidth) + "px",
                            height: (0.6 * scrollButtonWidth) + "px",
                            maxHeight: (0.6 * scrollButtonWidth) + "px",
                            marginTop: (0.5 * height - 0.3 * scrollButtonWidth) + "px",
                            marginLeft: (0.2 * scrollButtonWidth) + "px",
                            opacity: 0.7
                        }} />
                </div>}
            {(userControlled && (panels.length > 1)) &&
            <div
                id={idPrefix + "RightButton"}
                style={{
                    width: scrollButtonWidth + "px",
                    height: height + "px",
                    position: 'absolute',
                    left: (width - scrollButtonWidth) + "px",
                    top: '0px',
                    visibility : rightButtonVisibility
                }}
                className="carouselButtonPanel"
                onClick={() => { onRightClick(); }}>
                <img
                    src={s3URL + "rightCarouselButton.png"}
                    style={{
                        width: (0.6 * scrollButtonWidth) + "px",
                        maxWidth: (0.6 * scrollButtonWidth) + "px",
                        height: (0.6 * scrollButtonWidth) + "px",
                        maxHeight: (0.6 * scrollButtonWidth) + "px",
                        marginTop: (0.5 * height - 0.3 * scrollButtonWidth) + "px",
                        marginLeft: (0.2 * scrollButtonWidth) + "px",
                        opacity: 0.7
                    }}
                />
            </div>}
        </div>
    );

}